/**
 * Rejection handler for a lazily imported module's init().
 *
 * Without one, a failed chunk load (network drop, a deploy that replaced the hashed file)
 * or an init() that throws becomes an unhandled promise rejection. This keeps the failure
 * to the one module, and names it, instead of surfacing as an anonymous uncaught error.
 *
 * @param {string} name
 * @returns {(error: unknown) => void}
 */
export const moduleFailed = (name) => (error) => {
    console.error(`[4me] module "${name}" failed to load or initialise`, error);
};
